// Module
var code = "<universal-media-chooser on-media-determined=\"$ctrl.onMediaDetermined(media)\" on-engine-init=\"$ctrl.onRecorderInit(engine)\" options=\"$ctrl.umcOptions\" umc-instance-name=\"response-media\" ng-disabled=\"!$ctrl.isRecordEnabled()\"></universal-media-chooser>";
// Exports
module.exports = code;